import { Component, OnInit, inject } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { PrintOfficeService } from '../../../services/print-office.service';
import { AuthService } from '../../../services/auth/auth.service';
import { GetPrintOfficeRequestDto } from '../../../models/server-models/request-dtos/get-print-office-request-dto';
import { GetPrintOfficeResponseDto } from '../../../models/server-models/reseponse-dtos/get-print-office-response-dto';
import { PrintOfficeDto } from '../../../models/server-models/entities/print-office-dto';
import { ErrorService } from '../../../../../shared/services/error.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangePrintOfficeAvailabilityRequestDto } from '../../../models/server-models/request-dtos/change-office-availability-request-dto';
import { PrintOfficeAvailabilityTypes } from '../../../models/server-models/enums/print-office-availability-types';
import { Availability } from '../../../models/server-models/enums/availability';

@Component({
  selector: 'app-print-office-availability',
  templateUrl: './print-office-availability.page.html',
  styleUrls: ['./print-office-availability.page.scss'],
  standalone: false,
})
export class PrintOfficeAvailabilityPage implements OnInit {
  printOfficeService = inject(PrintOfficeService);
  authService = inject(AuthService);
  errorService = inject(ErrorService);

  availability = Availability;

  changeOfficeAvailability: ChangePrintOfficeAvailabilityRequestDto | null = null;

  printOffice: GetPrintOfficeResponseDto = { printOffice: null };

  applyAvailability(
    item: any,
    availability: number,
    officeVariationId: string | null,
    OfficeSizeId: string | null,
    OfficeTypeId: string | null,
    officeExtraId: string | null
  ): void {
    item.availability = availability;

    this.changeOfficeAvailability = {} as ChangePrintOfficeAvailabilityRequestDto;
    this.changeOfficeAvailability.availability = availability;
    this.changeOfficeAvailability.officePrintVariationId = officeVariationId;
    this.changeOfficeAvailability.officePaperSizeId = OfficeSizeId;
    this.changeOfficeAvailability.officePaperTypeId = OfficeTypeId;
    this.changeOfficeAvailability.officePaperExtraId = officeExtraId;

    if (item.printVariations) {
      //clicked on Printoffice
      this.changeOfficeAvailability.printOfficeAvailabilityTypes = PrintOfficeAvailabilityTypes.Office;
    } else if (item.paperSizes) {
      //clicked on Variation
      this.changeOfficeAvailability.printOfficeAvailabilityTypes = PrintOfficeAvailabilityTypes.Variation;

      for (const size of item.paperSizes) {
        size.availability = availability;
        if (size.paperTypes) {
          for (const paperType of size.paperTypes) {
            paperType.availability = availability;
            if (paperType.paperExtras) {
              for (const extra of paperType.paperExtras) {
                extra.availability = availability;
              }
            }
          }
        }
      }
    } else if (item.paperTypes) {
      //clicked on Size
      this.changeOfficeAvailability.printOfficeAvailabilityTypes = PrintOfficeAvailabilityTypes.Size;

      for (const paperType of item.paperTypes) {
        paperType.availability = availability;
        if (paperType.paperExtras) {
          for (const extra of paperType.paperExtras) {
            extra.availability = availability;
          }
        }
      }
    } else if (item.paperExtras) {
      //clicked on Type
      this.changeOfficeAvailability.printOfficeAvailabilityTypes = PrintOfficeAvailabilityTypes.Type;

      for (const extra of item.paperExtras) {
        extra.availability = availability;
      }
    } else if (item.paperExtraId) {
      //clicked on Extra
      this.changeOfficeAvailability.printOfficeAvailabilityTypes = PrintOfficeAvailabilityTypes.Extra;
    }

    this.printOfficeService.changeAvailability(this.changeOfficeAvailability).subscribe({
      error: (error: HttpErrorResponse) => {
        this.errorService.handleError(error);
      },
    });
  }
  constructor(private alertController: AlertController) {}

  async toggleAvailability(
    item: any,
    OfficeVariationId: string | null,
    OfficeSizeId: string | null,
    OfficeTypeId: string | null,
    OfficeExtraId: string | null
  ): Promise<void> {
    const newAvailability = item.availability === 1 ? 0 : 1;
    const label = newAvailability === 1 ? 'enable' : 'disable';

    const alert = await this.alertController.create({
      header: 'Confirm',
      message: `Are you sure you want to ${label} this item?`,
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
        },
        {
          text: 'Yes',
          handler: () => {
            this.applyAvailability(item, newAvailability, OfficeVariationId, OfficeSizeId, OfficeTypeId, OfficeExtraId);
          },
        },
      ],
    });

    await alert.present();
  }

  ngOnInit() {
    this.printOfficeService.getPrintOffice().subscribe({
      next: (printOffice) => {
        this.printOffice = printOffice;
      },
      error: (error: HttpErrorResponse) => {
        this.errorService.handleError(error);
      },
    });
  }
}
